export default __webpack_public_path__ + "static/01-01-prepare-edit-anything-81b1c007576b7c4b3c842a1f5d03da90.mp4";